import { CampaignV3I } from "@/lib/types/campaign";
import { CAMPAIGN_USER_STATUS } from "shared/lib/constants/campaign";

export const isUserApprovedToCall = (
  campaign_user_status: CampaignV3I["campaign_user_status"]
) => CAMPAIGN_USER_STATUS.AUDITION_APPROVED === campaign_user_status;
